import AjaxGetContent from "../../utils/ajax-get-content";
import Popup from "../../utils/popup";

class PopupZaloguj {
    constructor() {
        this.popupContent = $("#popup-content");
        this.signInButton = "#signInButton";
        this.zapomnialesHaslaButton = ".js-zapomniales-hasla-btn";
        this.zapomnialesHasla = "#zapomniales_hasla";
        this.zapomnialesHaslaTyp = "#zapomniales_hasla-typ";
        this.login = "#login";
        this.loginTyp = "#login-typ";
        this.loginPageUrl = "/uzytkownik/login.html";
        if (typeof pageUrlEncoded !== "undefined") {
            this.loginPageUrl += '?target=' + pageUrlEncoded;
        }
        this.popup = null;
        //this.loginLocation = loginLocation;
    }

    init() {
        const _this = this;
        const ajaxRequest = new AjaxGetContent(this.loginPageUrl);

        ajaxRequest.sendRequest();

        $(document).ajaxComplete(function (event, xhr, settings) {

            if (settings.url === _this.loginPageUrl) {
                const data = $(xhr.responseText);

                const login = data.find(_this.login);
                const loginValdationScript = data.find(_this.login).prev();
                //login.find(_this.loginTyp).val("koszyk");
                //login.find(_this.loginTyp).val(_this.loginLocation);

                const zapomnialesHasla = data.find(_this.zapomnialesHasla);
                const zapomnialesHaslaValdationScript = data
                    .find(_this.zapomnialesHasla)
                    .prev();
                zapomnialesHasla.find(_this.zapomnialesHaslaTyp).val("koszyk");

                const loginJQueryObject = login.add(loginValdationScript);
                const zapomnialesHaslaJQueryObject = zapomnialesHasla.add(
                    zapomnialesHaslaValdationScript
                );

                this.popup = new Popup(
                    loginJQueryObject,
                    _this.signInButton,
                    false,
                    false
                );
                this.popup = new Popup(
                    zapomnialesHaslaJQueryObject,
                    _this.zapomnialesHaslaButton,
                    false,
                    false
                );
            }
        });
    }
}

export default PopupZaloguj;
